import { IFormSelectItem } from '../../types/form-select-item.type';
import { IDateToType } from '../../types/user.type';

export const DATE_TO_TYPES: IFormSelectItem[] = Object.values(IDateToType).map((code) => ({
  code,
  name: `settings.date_to_types.${code}`,
}));
